var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWelcomeBlobSm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 162,
    viewBox: "0 0 123 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.0512 105.569C40.4384 124.805 9.5123 146.705 -18.9991 141.829C-47.5363 137.099 -73.6329 105.446 -76.5435 74.8596C-79.4542 44.2729 -59.153 14.6054 -37.4137 -6.6478C-15.8494 -27.7808 7.02973 -40.6723 27.0003 -38.8133C46.9451 -36.8078 63.9814 -20.0516 80.2144 -2.2281C96.2982 15.5691 111.43 34.4074 109.846 52.1117C108.112 69.7898 89.8131 86.3602 65.0512 105.569Z",
    fill: "#E8E8D8"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWelcomeBlobSm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/WelcomeBlobSm.3c9cab224d00eebf2cb5dbecd54a98fa.svg";